<!DOCTYPE html>
<html lang="en">
<head>
   <title> View Volume </title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-Content-Type-Options" content="nosniff">
</head>
<body>
<div class="card-pad"> 
<div class="fr-flex__container sticky-sub-header">
   <div class="fr-flex__col-8">
      <h3>View Volume</h3> 
   </div>
   <div class="fr-flex__col-4">
      <select class="form-control pull-right" [(ngModel)]="selectedOption"  (change)="onOptionChange()">
         <option disabled selected > Actions </option>
         <option *ngIf="editPrivilege" editAccrual [disabled]="volumeDetail?.InvoiceValue == null || volumeDetail?.statusName === 'Complete' || volumeDetail?.statusName === 'Not Applicable'"> Edit </option>
     </select>
     <div class="preview_section pull-right" *ngIf="currentIndex!==-1">
      <button  [class.previous]="currentIndex !== 0" (click)="previousRecord()" [disabled]="currentIndex === 0"><i class="pi pi-arrow-up" pTooltip="Preview" tooltipPosition="top"></i></button>
      <span class="numbers_list">{{getCurrentPositionText()}}</span>
      <button [class.next]="currentIndex !== listOfVolumes.length - 1" (click)="nextRecord()" [disabled]="currentIndex === listOfVolumes.length - 1"><i class="pi pi-arrow-down" pTooltip="Next" tooltipPosition="top"></i></button>
      </div>
     <a class="btn btn-primary-link backtolist pull-right" (click)="BackToList()">  <i class="pi pi-arrow-left"></i> Back to list </a>
     </div>
</div>
<div class="scroll-start-here-sub-tabs"> 
<div class="fr-flex__container m-t-20">
    <div class="fr-flex__col-4">
       <div class="fr-form__view">
          <label> Month  <em> * </em></label>
          <span> <em> {{ volumeDetail?.volumeDate | date:'MMMM yyyy' }}  </em></span>
       </div>
    </div>
    <div class="fr-flex__col-4">
      <div class="fr-form__view">
         <label> Invoice Amount   <em> * </em></label>
         <span *ngIf="this.volumeDetail?.invoiceAmount==null"> <em> -- </em></span>
         <span *ngIf="this.volumeDetail?.invoiceAmount!=null"> <em>  {{ getFormattedValue(volumeDetail?.invoiceAmount, currency) }} </em></span>
      </div>
   </div>
    <div class="fr-flex__col-4">
      <div class="fr-form__view">
         <label> Volume Update Status   <em> * </em></label>
         <span *ngIf="this.volumeDetail?.statusName==null"> <em> -- </em></span>
         <span *ngIf="this.volumeDetail?.statusName!=null"> <em>  {{ volumeDetail?.statusName }} </em></span>
      </div>
   </div>
   <div class="fr-flex__col-4">
    <div class="fr-form__view" style="margin-bottom: 5px;">
      <label> Product Applicability <em> * </em></label>
      <span> {{ volumeDetail?.productApplicability == true || volumeDetail?.productApplicability == 'true' ? 'Yes' : 'No'  }}  </span>

   </div>
   </div>
      <div class="fr-flex__col-4" *ngIf="volumeDetail?.productApplicability">
    <div class="fr-form__view" style="margin-bottom: 5px;">
      <label> Data Entry Method <em> * </em></label>
      <span> {{ volumeDetail?.dataEntry == true || volumeDetail?.dataEntry == 'true' ? 'Upload File' : 'Manual Entry'  }}  </span>

   </div>
   </div>
  <div class="fr-flex__col-4"
    *ngIf="volumeDetail?.productApplicability && (volumeDetail?.dataEntry == true || volumeDetail?.dataEntry == 'true')">
    <div class="fr-form__view" style="margin-bottom: 5px;">
      <label> Attachments <i pInputText pTooltip="Only 20 Attachments allowed." tooltipPosition="top"
          class="pi pi-info-circle"> </i></label>
  
      <span
        *ngIf="!volumeDetail?.financeContractVolumeAttachments || volumeDetail.financeContractVolumeAttachments.length == 0">
        <em> -- </em>
      </span>
      <div *ngIf="volumeDetail?.financeContractVolumeAttachments?.length > 0">
         <a class="attachment-active" routerLinkActive="active"
         (click)="downloadAttachment(volumeDetail.financeContractVolumeAttachments[0])">
<span 
  [pTooltip]="volumeDetail.financeContractVolumeAttachments[0]?.fileName?.length > 40 
              ? volumeDetail.financeContractVolumeAttachments[0]?.fileName 
              : null"
  tooltipPosition="top">
        <em>{{ volumeDetail.financeContractVolumeAttachments[0]?.fileName }}</em>
          </span>
        <i pInputText pTooltip="Download" tooltipPosition="top" class="pi pi-download ml-2"></i>
      </a>
      </div>
  
    </div>
  </div>
<div class="fr-flex__col-12"  
     *ngIf="volumeDetail?.productApplicability && (volumeDetail?.dataEntry == true || volumeDetail?.dataEntry == 'true')">

    <div *ngIf="volumeDetail?.financeContractVolumeAttachments?.length > 1">
    <div class="fr-form__group">
      <div class="display-inline-block" 
           *ngFor="let file of volumeDetail.financeContractVolumeAttachments.slice(1)"
           style="margin-right: 5px; margin-bottom: 5px;">
           
        <a class="form-list-active"
           (click)="downloadAttachment(file)"
           style="width: auto; cursor: pointer; margin: 0px; padding: 10px;">

          <span 
            [pTooltip]="file?.fileName?.length > 40 ? file.fileName : null"
            tooltipPosition="top">
            <em>{{ file?.fileName }}</em>
          </span>

          <i class="pi pi-download ml-2" pTooltip="Download" tooltipPosition="top"></i>
        </a>
      </div>
  </div>
  </div>
</div>
   
 </div> 
         <div *ngIf="volumeDetail?.productApplicability == false || volumeDetail?.productApplicability == 'false'" class="fr-flex__col-8 m-b-20">
            <div class="note-display-blue">
              <i class="pi pi-info-circle"></i>
              <span>
                Since work is not Product Specific, this invoice amount will not be attributed towards any Products.
              </span>
            </div>
          </div>

<div class="fr-flex__col-12 m-b-50">
      <div class="fr-flex__container" *ngIf="volumeDetail?.productApplicability == true || volumeDetail?.productApplicability == 'true'">
  <div class="fr-flex__col-12">
  
    <div style="display: flex; align-items: center; gap: 15px; padding-bottom: 15px;">
    <h4 class="m-t-20" style="margin: 0;">Product Details</h4>
    <div *ngIf="volumeDetail?.dataEntry == true || volumeDetail?.dataEntry == 'true'"
         style="display: flex; align-items: center; gap: 8px;">

        <p-checkbox inputId="overrideCheck"  [disabled]="true" [binary]="true" [(ngModel)]="isOverrideChecked" (onChange)="onOverrideChange()" [style]="{ transform: 'scale(1.5)' }"></p-checkbox>

        <label for="overrideCheck" style="margin:0;">
            Override System Calculation
        </label>

    </div>

</div>
<div class="fr-flex__col-2" style="padding-left:0px; width: 300px;">
  <div class="fr-form__group" style="margin:0;">
    <div class="search-input-wrapper">

      <i class="pi pi-search"></i>

      <input type="text" class="form-control" pInputText placeholder="Search Product"
        style="padding-left:34px; padding-right:30px;"
        [(ngModel)]="searchText"
        (ngModelChange)="filterProducts()"
        [ngModelOptions]="{ standalone: true }"
         />

      <i class="pi pi-times"
      *ngIf="searchText"
      (click)="clearFilter()">
      </i>

    </div>
  </div>
</div>

<p-table class="primeng-table-custom" [value]="filteredProducts" [scrollable]="true"
        [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100]" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines"
         *ngIf="volumeDetail?.dataEntry == false || volumeDetail?.dataEntry == 'false'">

        <ng-template pTemplate="header" class="card flex justify-content-center">
            <tr>
                <th style="text-align:center">Product Name</th>
                <th style="text-align:center">% Cost Attribution</th>
                <th style="text-align:center">Cost</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData style="align-items: center;">
            <tr>
                <td style="text-align: center;">{{ rowData.productName }}</td>
                <td style="text-align: center;">{{ rowData.units }}</td>
                <td style="text-align: center;">{{ rowData.cost | number:'1.2-2' }}</td>
            </tr>
        </ng-template>

      <ng-template pTemplate="footer">
    <tr style="height: 26px;">
       <td style="padding: 0; text-align: center;"><span style="font-size: 12px; line-height: 1;">Total</span></td>
       <td style="padding: 0; text-align: center;"><span style="font-size: 12px; line-height: 1;">{{ getTotalUnits() }}</span></td>
       <td style="padding: 0; text-align: center;"><span style="font-size: 12px; line-height: 1;">{{ getTotalCost() | number:'1.2-2' }}</span></td>
    </tr>
</ng-template>

</p-table>
<p-table class="primeng-table-custom table-center-all m-t-4" [value]="filteredProducts"
                         [resizableColumns]="true" columnResizeMode="expand"
                         styleClass="p-datatable-striped p-datatable-gridlines" [scrollable]="true"
                         #contractDataTable [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100,200]"
                         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
                         [showCurrentPageReport]="true"
                         *ngIf="volumeDetail?.dataEntry == true || volumeDetail?.dataEntry == 'true'">
 
                  <ng-template pTemplate="header">
                    <tr>
                      <th rowspan="2" style="text-align: center;">Product</th>
                      <th colspan="2" style="text-align: center;">System Calculated</th>
                      <th colspan="2" style="text-align: center;">Overwritten</th>
                    </tr>
                    <tr>
                      <th style="text-align: center;">
                        Units Of
                        the Month
                      </th>
                      <th style="text-align: center;">
                        Cost of
                        the Month
                      </th>
                      <th style="text-align: center;">
                        % Cost
                        Attribution
                      </th>
                      <th style="text-align: center;">
                        Cost of
                        the Month
                      </th>
                    </tr>
                  </ng-template>
 
                  <ng-template pTemplate="body" let-rowData>
                    <tr>
                      <td>{{ rowData.productName }}</td>
                      <td>{{ rowData.systemCalculatedUnits }}</td>
                      <td>{{ rowData.systemCalculatedCost }}</td>
                      <td>{{ rowData.units }}</td>
                      <td>{{ rowData.cost }}</td>
                    </tr>
                  </ng-template>
</p-table>
 
  </div>
      </div>
</div>


 <div class="fr-flex__container">
   <div class="fr-flex__col-4">
      <div class="fr-form__view">
         <label> Modified By</label>
      <span  *ngIf="updatedBy!=null && updatedBy != undefined && updatedBy != ''"> <em> {{updatedBy}}</em></span>
      <span  *ngIf="updatedBy==null|| updatedBy == undefined || updatedBy == ''"> <em> --</em></span>
      </div>
   </div>
   <div class="fr-flex__col-4">
    <div class="fr-form__view">
      <label> Modified Date & Time </label>
      <span *ngIf="updatedBy!=null && updatedBy != undefined && updatedBy != ''"> <em> {{volumeDetail?.updatedDate | date: _dateformart.DateTimeWithZone }} {{_dateformart.DisplayUTC}}</em></span>
      <span *ngIf="updatedBy ==null || updatedBy == undefined || updatedBy == ''"> <em> --</em></span>
    </div>
    </div>
   </div>
</div>
</div>
</body>
</html>
